import { environmentConfig } from '@/config/enviromentConfig'

const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const CONTAINER_ID = 'cf-turnstile-container'
const EXECUTE_TIMEOUT_MS = 5000

export const WIDGET_ID = 'mzansiRhythm'

let initialized = false
let widgetId = null
let pending = null

function resolvePending(token) {
    const resolve = pending
    pending = null
    if (resolve) resolve(token)
}

function rearmWidget() {
    try {
        if (widgetId) window.turnstile?.reset(widgetId)
    } catch {
        // Observe-only: a failed re-arm just means the next action goes headerless.
    }
}

function renderWidget() {
    try {
        const params = {
            sitekey: environmentConfig.turnstileSiteKey,
            execution: 'execute',
            appearance: 'execute',
            callback: (token) => resolvePending(token),
            'error-callback': () => resolvePending(null),
            'timeout-callback': () => resolvePending(null),
        }
        widgetId = window.turnstile?.render('#' + CONTAINER_ID, params) ?? null
        rearmWidget()
    } catch {
        widgetId = null
    }
}

export function initTurnstile() {
    if (initialized || !environmentConfig.turnstileSiteKey) return
    initialized = true
    try {
        const container = document.createElement('div')
        container.id = CONTAINER_ID
        container.style.cssText =
            'position:fixed;left:-9999px;top:0;width:300px;height:65px;opacity:0;pointer-events:none;'
        document.body.appendChild(container)

        const script = document.createElement('script')
        script.src = SCRIPT_URL
        script.async = true
        script.defer = true
        script.onload = renderWidget
        document.head.appendChild(script)
    } catch {
        // Telemetry/CAPTCHA never breaks app init.
    }
}

export function getCaptchaToken(action) {
    if (!environmentConfig.turnstileSiteKey || !widgetId || !window.turnstile) {
        return Promise.resolve(null)
    }
    return new Promise((resolve) => {
        let timer = null
        const settle = (token) => {
            if (timer === null) return
            clearTimeout(timer)
            timer = null
            if (pending === settle) pending = null
            resolve(token)
            rearmWidget()
        }
        pending = settle
        timer = setTimeout(() => settle(null), EXECUTE_TIMEOUT_MS)
        try {
            window.turnstile.execute('#' + CONTAINER_ID, { action })
        } catch {
            settle(null)
        }
    }).catch(() => null)
}
